import { render } from "./GoogleLogin.vue?vue&type=template&id=bccd0112&bindings={\"loginWithGoogle\":\"options\"}"
import script from "./GoogleLogin.vue?vue&type=script&lang=js"
export * from "./GoogleLogin.vue?vue&type=script&lang=js"
script.render = render

export default script